import { atom } from 'recoil';
import { TaskView } from '~/backend/connector-next-api/connector-next-schemas';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { DoseTargetData } from '~/utils/transforms/doseTargetsTransforms';

export type DosePredictionTaskState = {
    model?: GenerationModelDetails;
    targets?: DoseTargetData[];
    output?: TaskView;
    polling?: boolean;
};

export const dosePredictionTaskState = atom<DosePredictionTaskState>({
    key: 'dosePredictionTaskState',
    default: undefined,
});
